<template>
  <div class="index-container">
    <!-- PC端内容 -->
    <div class="pc-content" v-if="!isMobile">
      <div class="page-wrap">
        <div class="header-wrap">
          <div class="area-page">
            <div class="header flex align-center">
              <img src="../assets/images/pc/icon.png" alt="" />
              <div>深圳木维科技信息技术有限公司</div>
            </div>
          </div>
        </div>

        <div class="company-wrap">
          <div class="area-page">
            <div class="company flex-column align-center">
              <img
                src="../assets/images/pc/company-title.png"
                alt=""
                class="company-title"
              />
              <div class="flex align-center" style="align-items: stretch">
                <div class="flex-column justify-around flex-sub">
                  <div class="company-name">深圳木维科技信息技术有限公司</div>
                  <div class="time">since 2025</div>
                  <div>
                    <p>
                      木维科技是一家综合性服务企业，致力于通过互联网技术，将线下业务场景延伸至线上，构建多方共赢的生态体系。
                    </p>
                    <p>
                      我们以用户为中心，在提供便捷服务的过程中持续创造价值，以真诚和信任对待每一位客户，努力打造更高效、更智能的一站式服务平台。
                    </p>
                  </div>
                </div>
                <img
                  src="../assets/images/pc/company-img.png"
                  alt=""
                  class="company-img"
                />
              </div>

              <img
                src="../assets/images/pc/company-right.png"
                alt=""
                class="company-right"
              />
            </div>
          </div>
        </div>

        <div class="product-wrap">
          <div class="area-page">
            <div class="product-content">
              <img
                src="../assets/images/pc/product-title.png"
                alt=""
                class="product-title"
              />

              <div>
                <div class="flex justify-between align-center">
                  <div>
                    <div class="p-title white">合创科技-首页展示</div>
                    <div class="p-text white">
                      合创科技是一款专为服务商设计打造、协助服务商进行推广扩展的移动工具。让服务商可以享受一站式运营管理体验，邀请好友等功能体验。
                    </div>
                  </div>
                  <img
                    src="../assets/images/pc/p1.png"
                    alt=""
                    class="p-img ml-100"
                  />
                </div>
                <div class="flex justify-between align-center">
                  <img
                    src="../assets/images/pc/p2.png"
                    alt=""
                    class="p-img mr-100"
                  />
                  <div>
                    <div class="p-title c236">个人中心</div>
                    <div>
                      <p>个人信息管理</p>
                      <div class="p-text c666">
                        完善个人资料，支持更改头像和个性昵称，享受自我。
                      </div>
                    </div>
                    <div>
                      <p>等级的提升</p>
                      <div class="p-text c666">
                        随时更新等级信息，见证成长与进步。
                      </div>
                    </div>
                    <div>
                      <p>安全与设置</p>
                      <div class="p-text c666">
                        采用高强度加密技术，确保账户安全无忧。
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="logen">
          <div class="area-page">
            <div class="logen-content flex justify-center align-center">
              <div class="mr-30">服务创造价值</div>
              <div>专业赢得信任</div>
            </div>
          </div>
        </div>

        <div class="wh-wrap">
          <div class="area-page">
            <div class="wh-content flex-column align-center justify-center">
              <img
                src="../assets/images/pc/wh-title.png"
                alt=""
                class="wh-title"
              />
              <img src="../assets/images/pc/wh-img.png" alt="" class="wh-img" />
            </div>
          </div>
        </div>
        <div class="download-wrap">
          <div class="area-page">
            <div
              class="download-content flex-column align-center justify-center"
            >
              <p>下载【合创科技】APP，开启创业之路</p>
              <div class="download-button">
                打开手机【应用商店】/【App Store】下载
              </div>
            </div>
          </div>
        </div>
        <div class="foot-wrap">
          <div class="area-page">
            <div class="foot-content flex-column">
              <img
                src="../assets/images/pc/foot-title.png"
                alt=""
                class="foot-title"
              />
              <img
                src="../assets/images/pc/foot-img.png"
                alt=""
                class="foot-img"
              />
            </div>
          </div>
        </div>

        <div class="copyright">
          <div class="area-page">
            <div
              style="
                text-align: center;
                font-size: 14px;
                color: #62646c;
                line-height: 50px;
              "
            >
              深圳木维科技信息技术有限公司版权所有 All Right Reserved
              <a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                style="color: blue; cursor: pointer"
                >粤ICP备2025381041号</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端内容 -->

    <div class="mobile-content" v-else>
      <!-- 添加头部标题 -->
      <div class="m-title">
        <img src="../assets/images/mobile/mw-title.png" alt="" />
      </div>
      <div class="m-header">
        <img
          src="../assets/images/mobile/header-bg.png"
          alt=""
          class="m-banner"
        />
      </div>

      <div class="m-company">
        <div class="flex align-center justify-center">
          <img
            src="../assets/images/mobile/company-title.png"
            alt=""
            class="m-company-title"
          />
        </div>

        <div class="m-company-content">
          <p>深圳木维科技信息技术有限公司</p>
          <div class="m-company-text">
            木维科技是一家综合性服务企业，致力于通过互联网技术，将线下业务场景延伸至线上，构建多方共赢的生态体系。
          </div>
          <div class="m-company-text">
            我们以用户为中心，在提供便捷服务的过程中持续创造价值，以真诚和信任对待每一位客户，努力打造更高效、更智能的一站式服务平台。
          </div>
          <div class="m-company-img">
            <img src="../assets/images/mobile/company.png" alt="" />
          </div>
        </div>
      </div>

      <div class="m-product">
        <div class="flex align-center justify-center m-product-title">
          <img src="../assets/images/mobile/p-title.png" alt="" />
        </div>
        <div class="m-product-content">
          <div class="m-product-item bg-blue">
            <div class="m-product-text">
              <h3>合创科技-首页展示</h3>
              <p>
                合创科技是一款专为服务商设计打造、协助服务商进行推广扩展的移动工具。让服务商可以享受一站式运营管理体验，邀请好友等功能体验。
              </p>
            </div>
            <div class="m-product-img">
              <img src="../assets/images/mobile/p1.png" alt="" />
            </div>
          </div>
          <div class="m-product-item">
            <div class="m-product-text">
              <h3>个人中心</h3>
              <div class="feature-item">
                <h4>个人信息管理</h4>
                <p>完善个人资料，支持更改头像和个性昵称，享受自我。</p>
              </div>
              <div class="feature-item">
                <h4>等级的提升</h4>
                <p>随时更新等级信息，见证成长与进步。</p>
              </div>
              <div class="feature-item">
                <h4>安全与设置</h4>
                <p>采用高强度加密技术，确保账户安全无忧。</p>
              </div>
            </div>
            <div class="m-product-img">
              <img src="../assets/images/mobile/p2.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div class="m-slogan">
        <div class="m-slogan-text">
          <span>服务创造价值</span>
          <span>专业赢得信任</span>
        </div>
      </div>

      <div class="m-culture">
        <div class="flex align-center justify-center">
          <img
            src="../assets/images/mobile/wh-title.png"
            alt=""
            class="wh-title"
          />
        </div>
        <div class="wh-img-wrap">
          <img src="../assets/images/mobile/wh-img.png" alt="" />
        </div>
      </div>
      <div class="m-footer">
        <div class="m-footer-content">
          <img
            src="../assets/images/mobile/logo.png"
            alt=""
            class="m-footer-logo"
          />
          <div class="footer-info">
            <div class="info-item">
              <span class="label">公司介绍：</span>
              <span class="value">成就平凡人的创业梦想</span>
            </div>
            <div class="info-item">
              <span class="label">公司产品：</span>
              <span class="value">合创科技</span>
            </div>
            <div class="info-item">
              <span class="label">联系电话：</span>
              <span class="value">400-654-9559</span>
            </div>
          </div>
          <div class="m-footer-text">
            <p>深圳木维科技信息技术有限公司版权所有</p>
            <p>
              <a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                class="icp-link"
              >
                粤ICP备2025381041号
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      isMobile: false,
    };
  },
  created() {
    this.checkDevice();
    window.addEventListener("resize", this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkDevice);
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style lang="scss">
.index-container {
  width: 100%;
  min-height: 100vh;
  overflow: auto;
}

body,
html {
  padding: 0;
  margin: 0;
}
/* PC端样式 */
.pc-content {
  width: 100%;
  .area-page {
    width: 1200px;
    margin: 0 auto;
  }

  .header-wrap {
    width: 100%;
    height: 800px;
    background: url("../assets/images/pc/header-bg.png");
    background-size: 100% 100%;
  }
  .header {
    padding-top: 24px;
  }
  .header img {
    width: 80px;
    height: 42px;
    margin-right: 16px;
  }
  .header div {
    font-weight: 600;
    font-size: 28px;
    color: #ffffff;
  }

  .company-wrap {
    width: 100%;
    height: 878px;
    background: #f7f7f9;
    padding: 96px 0 148px;
    box-sizing: border-box;
  }
  .company {
    position: relative;
  }
  .company-title {
    width: 977px;
    height: 100px;
    margin-bottom: 60px;
  }
  .company-img {
    width: 603px;
    height: 474px;
    margin-left: 30px;
    position: relative;
    z-index: 2;
  }
  .company-name {
    font-weight: 600;
    font-size: 28px;
    color: #404158;
  }
  .company-wrap p {
    font-weight: 400;
    font-size: 24px;
    color: #61627a;
    line-height: 36px;
    margin-bottom: 10px;
  }
  .company .time {
    font-family: PingFangSC, PingFang SC;
    font-weight: 200;
    font-size: 32px;
    color: #8aa4e2;
  }
  .company-right {
    width: 217px;
    height: 233px;
    position: absolute;
    z-index: 1;
    right: -120px;
    bottom: -106px;
  }

  .product-wrap {
    width: 100%;
    height: 1768px;
    background: url("../assets/images/pc/product-bg.png");
    background-size: 100% 100%;
    padding: 90px 0 123px;
    box-sizing: border-box;
  }

  .product-title {
    width: 977px;
    height: 100px;
    margin-bottom: 93px;
  }
  .p-img {
    width: 735px;
  }
  .p-title {
    color: #333333;
    font-size: 32px;
    margin-bottom: 40px;
  }

  .p-title.white {
    color: #fff;
  }
  .p-title.c236 {
    color: #151236;
  }
  .p-text {
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    line-height: 33px;
  }

  .white {
    color: #fff;
  }
  .c333 {
    color: #333;
  }
  .c666 {
    color: #666;
  }
  .ml-100 {
    margin-left: 100px;
  }
  .mr-100 {
    margin-right: 100px;
  }
  p {
    font-size: 24px;
    color: #333333;
    line-height: 33px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .logen {
    width: 100%;
    height: 200px;
    background: url("../assets/images/pc/logen.png");
  }
  .logen-content {
    width: 1200px;
    height: 200px;
    text-align: center;
    font-weight: 600;
    font-size: 42px;
    color: #ffffff;
    line-height: 200px;
  }

  .wh-wrap {
    width: 100%;
    height: 1008px;
    background: url("../assets/images/pc/wh-bg.png");
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 106px 0 140px;
  }

  .wh-title {
    width: 977px;
    height: 100px;
    margin-bottom: 100px;
  }
  .wh-img {
    width: 1200px;
    height: 600px;
  }

  .download-wrap {
    width: 100%;
    height: 300px;
    background: url("../assets/images/pc/download-bg.png");
    background-size: 100% 100%;
    box-sizing: border-box;
  }
  .download-content {
    height: 300px;
    color: #fff;
  }
  .download-content p {
    font-weight: 500;
    font-size: 40px;
    color: #ffffff;
    line-height: 56px;
    margin-bottom: 20px;
  }
  .download-content div {
    width: 498px;
    height: 48px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 24px;

    font-weight: 400;
    font-size: 24px;
    color: #ffffff;
    line-height: 48px;
    text-align: center;
  }
  .foot-wrap {
    width: 100%;
    height: 417px;

    box-sizing: border-box;
    padding: 62px 0 106px;
  }

  .foot-title {
    width: 250px;
    height: 64px;
    margin-bottom: 40px;
  }
  .foot-img {
    width: 1200px;
    height: 147px;
  }

  .copyright {
    width: 100%;
    height: 50px;
    background: #dcdfe6;
  }
}

.mr-10 {
  margin-right: 10px;
}
.mr-30 {
  margin-right: 30px;
}
.flex {
  display: flex;
}
.flex-sub {
  flex: 1;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-end {
  justify-content: flex-end;
}
.align-end {
  align-items: flex-end;
}

.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.page-wrap {
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 768px) {
  .pc-content {
    display: none;
  }
}

@media screen and (min-width: 769px) {
  .mobile-content {
    display: none;
  }
}
</style>

<style lang="scss">
.mobile-content {
  width: 100%;
  overflow-x: hidden;
  /* 添加标题样式 */
  .m-title {
    height: 44px;
    display: flex;
    align-items: center;
    padding-left: 16px;
    background: #fff;

    img {
      width: 104px;
      height: 32px;
    }
  }
  .m-header {
    width: 100%;
    height: 160px;
    .m-banner {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  h2 {
    font-size: 24px;
    text-align: center;
    margin: 30px 0;
    color: #333;
  }

  .m-company {
    padding: 20px 15px;
    background: #fff;
    .m-company-title {
      width: 214px;
      height: 40px;
      margin-bottom: 20px;
    }
    &-content {
      p {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 15px;
      }
    }

    &-text {
      font-size: 16px;
      line-height: 1.6;
      color: #666;
      margin-bottom: 20px;
    }

    &-img {
      width: 100%;
      img {
        width: 100%;
        border-radius: 8px;
      }
    }
  }

  .m-product {
    .m-product-title {
      padding: 20px;
      background: #f5f5f8;
      img {
        width: 284px;
        height: 40px;
      }
    }

    &-item {
      padding: 15px 20px;
    }

    &-text {
      h3 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #333;
      }

      p {
        font-size: 14px;
        line-height: 1.6;
        color: #666;
      }
    }

    &-img {
      margin-top: 20px;
      img {
        width: 100%;
      }
    }
    .bg-blue {
      background: #2968ff;
      h3 {
        color: #fff;
      }
      p {
        color: #fff;
      }
    }
    .feature-item {
      margin-bottom: 15px;
      h4 {
        font-size: 16px;
        margin-bottom: 8px;
      }
    }
  }

  .m-slogan {
    height: 100px;
    background: url("../assets/images/mobile/slogan-bg.png") no-repeat center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;

    &-text {
      color: #fff;
      font-size: 20px;
      font-weight: bold;

      span {
        margin: 0 15px;
      }
    }
  }

  .m-culture {
    background: #f5f5f8;
    padding: 24px 15px;

    .wh-title {
      width: 226px;
      height: 40px;
      margin-bottom: 24px;
    }

    .wh-img-wrap {
      width: 100%;
      img {
        width: 100%;
        display: block;
      }
    }
  }

  .m-download {
    padding: 30px 15px;
    background: linear-gradient(135deg, #4e6ef2, #6e8ff2);
    text-align: center;
    color: #fff;

    p {
      font-size: 20px;
      margin-bottom: 20px;
    }

    &-btn {
      width: 80%;
      margin: 0 auto;
      padding: 12px 0;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 25px;
      font-size: 16px;
    }
  }

  .m-footer {
    padding: 0px 15px 20px;
    background: #f5f5f5;

    &-content {
      .footer-info {
        text-align: left;
        margin-bottom: 20px;

        .info-item {
          margin-bottom: 10px;
          display: flex;

          .label {
            font-weight: bold;
            color: #333;
            width: 85px;
          }

          .value {
            color: #666;
            flex: 1;
          }
        }
      }
    }

    &-logo {
      width: 120px;
      margin-bottom: 20px;
    }

    &-text {
      margin-top: 20px;
      text-align: center;

      .icp-link {
        color: #2968ff;
        text-decoration: none;
      }

      p {
        font-size: 14px;
        color: #666;
        line-height: 1.8;
        text-align: center;
      }
    }
  }
}
</style>
